<template>
  <MaskLayer v-if="isOpen">
    <div class="bg-white vh-100 position-fixed d-flex flex-column animate__animated animate__slideInRight" :class="sheetClass" style="right:0;top:0;">
      <div class="position-absolute" style="top: 11px; left: -40px; z-index: 1;">
        <button type="button" @click="close" class="close" aria-label="Close">
          <i class="material-icons md-24 text-white">
            close
          </i>
        </button>
      </div>
      <slot />
    </div>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: { MaskLayer },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    sheetClass: {
      type: String,
      default: 'w-25',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
